import { ReportState } from "../../../types/Rows";

// DayPilot renderuje pola html/toolTip jako HTML - dane wpisane przez użytkowników muszą być escapowane
export const escapeHtml = (value: unknown): string =>
  String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

export const getStateColor = (state: ReportState): string => {
  switch (state) {
    case ReportState.INPROGRESS:
      return "#3b82f6"; // blue
    case ReportState.TO_VERIFY:
      return "#f59e0b"; // amber
    case ReportState.TO_CORRECT:
      return "#ef4444"; // red
    case ReportState.ACCEPTED:
      return "#10b981"; // green
    default:
      return "#6b7280"; // gray
  }
};

export const getStateName = (state: ReportState, t: any): string => {
  switch (state) {
    case ReportState.INPROGRESS:
      return t("inProgress");
    case ReportState.TO_VERIFY:
      return t("toVerify");
    case ReportState.TO_CORRECT:
      return t("toCorrect");
    case ReportState.ACCEPTED:
      return t("accepted");
    default:
      return "Unknown";
  }
};

export const parseDate = (dateStr: string): Date => {
  // Extract just the date part (YYYY-MM-DD)
  const datePart = dateStr.includes('T') ? dateStr.split('T')[0] : dateStr;
  const [year, month, day] = datePart.split('-').map(Number);
  // Create date using local timezone (month is 0-based in JS)
  return new Date(year, month - 1, day);
};

export const formatDateForCalendar = (date: Date): string => {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  return `${year}-${month}-${day}`;
};

// Data dla DayPilot jako tekst „RRRR-MM-DD” (bez strefy): new DayPilot.Date(obiektDate) czyta go w UTC
export const toDayPilotDate = (date: Date): string => formatDateForCalendar(date);

export const getMonthRange = (date: Date) => {
  // Get the first day of the month
  const firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
  
  // Get the last day of the month
  const lastDayOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  
  // For calendar views, we need to include the entire previous and next months
  // to cover all visible dates on a 6-week calendar grid
  const startDate = new Date(date.getFullYear(), date.getMonth() - 1, 1);
  const endDate = new Date(date.getFullYear(), date.getMonth() + 2, 0);
  
  return { startDate, endDate };
};
